import { createSelector, createFeatureSelector } from '@ngrx/store';
import { MainModule } from "./main.reducer";

import * as paymentActions from '../actions/payment.actions';

export type Actions = paymentActions.All;

export interface PaymentState {
  cards: any[];
  default: string;
  loading?: boolean;
  error?: any;
}

export const initialValue: PaymentState = {
  cards: [],
  default: null,
  loading: false,
}

export function paymentReducer(state: PaymentState = initialValue, action: Actions) {
  switch (action.type) {
    case paymentActions.GET_CARDS:
      return { ...state, loading: true };
    case paymentActions.GET_CARDS_SUCCESS:
      return { ...state, loading: false, cards: action.payload };
    case paymentActions.GET_CARDS_FAILED:
      return { ...state, loading: false, cards: [], error: action.payload };
    case paymentActions.SET_DEFAULT_CARD:
      return { ...state, default: action.payload };
    case paymentActions.SET_CARDS_INIT:
      return initialValue;
    default:
      return state;
  }
}

export const getMainModule = createFeatureSelector<MainModule>('mainModule');
export const getPaymentState = createSelector(getMainModule, (state: MainModule) => state.paymentState);


// WEBPACK FOOTER //
// ./src/ngrx/reducers/payment.reducer.ts